module.exports = __webpack_public_path__ + "static/media/icon8-2.92d5d1a9.png";